export const md5RegExp = new RegExp('^[a-f,A-F,0-9]{32}$')
export const sha1RegExp = new RegExp('^[a-f,A-F,0-9]{40}$')
export const sha256RegExp = new RegExp('^[a-f,A-F,0-9]{64}$')
export const sha512RegExp = new RegExp('^[a-f,A-F,0-9]{128}$')
export const ipv4RegExp = new RegExp('^((2[0-4]\\d|25[0-5]|1\\d\\d|[1-9]\\d|[1-9])\\.)((2[0-4]\\d|25[0-5]|1\\d\\d|[1-9]\\d|\\d)\\.){2}(2[0-4]\\d|25[0-5]|1\\d\\d|[1-9]\\d|\\d)$')
export const emailRegExp = new RegExp('^[A-Za-z\\d]+([-_.][A-Za-z\\d]+)*@([A-Za-z\\d]+[-_.])+[A-Za-z\\d]{2,4}$')
export const urlRegExp = new RegExp('^((https?:)?//)?(?=.{0,2000}$)[\\w-]{1,63}(\\.[\\w-]{1,63})+.*/([\\w-]{1,63})*')
export const domainRegExp = new RegExp('^((https?:)?//)?(?=.{0,2000}$)[\\w-]{1,63}(\\.[\\w-]{1,63})+.*$')
export const cnnvdRegExp = new RegExp('^CNNVD-\\d{6}-\\d{3,4}$', 'i')
export const cveRegExp = new RegExp('^CVE-\\d{4}-\\d{4,5}$', 'i')
export const cnvdRegExp = new RegExp('^CNVD-\\d{4}-\\d{5,10}$', 'i')
export const macAddressRegExp = new RegExp('^([0-9a-fA-F]{2})(([/\\s:-][0-9a-fA-F]{2}){5})$')
/** 密码正则 至少包括字母数字特殊字符中任意2种，长度至少8 */
export const passwordRegExp = new RegExp('(?!^\\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\\S{8,}$')
export const phoneRegExp = new RegExp('(^1[3456789]\\d{9}$)')
/**  匹配手机号码/邮箱 */
export const phoneOrEmailRegExp = new RegExp('(^1[3456789]\\d{9}$)|(^[A-Za-z\\d]+([-_.][A-Za-z\\d]+)*@([A-Za-z\\d]+[-_.])+[A-Za-z\\d]{2,4}$)')
export function matchCertQuery (chars: string) {
  const certStart = /^cert(:|：)\s*/i
  if (!certStart.test(chars)) {
    return ''
  }

  const hash = chars.replace(certStart, '')
  if (md5RegExp.test(hash) || sha1RegExp.test(hash) || sha256RegExp.test(hash) || sha512RegExp.test(hash)) {
    return hash
  }
  return ''
}
